import { BoxProps, Skeleton } from "@mui/material";
import { BACKEND } from "constants/settings";
import useAuth from "hooks/useAuth";
import Image from "pages/supplier_page/components/Image";
import NewDostLogo from "../assets/logo/newDostLogo.png";
import DostLogo from "../assets/logo/newDostLogoWithoutText.png";
import Volotea from "assets/logo/Volotea.svg";
import VoloteaLogo from "assets/logo/VoloteaLogo.svg";
import DostSageLogo from "assets/logo/DostSageLogo.svg";
import { useSelector, RootState } from "redux/store";
import { CustomTheme } from "enums/customTheme";

interface SupplierLogoProps extends BoxProps {
  isCollapse?: boolean;
  isDrawer?: boolean;
}

const SupplierLogo: React.FC<SupplierLogoProps> = ({ isCollapse, isDrawer }) => {
  const currentSupplierId = window.location.pathname.split("/")[1];
  const {
    customLogo: { hasCustomLogo, isLoadingCustomLogo },
  } = useAuth();

  const customTheme = useSelector(
    (state: RootState) => state.supplier?.supplier?.customTheme,
  );
  const showSageBranding = customTheme === CustomTheme.Sage && !isCollapse && isDrawer;

  // Highest priority: Custom theme
  if (customTheme === CustomTheme.Volotea) {
    return isCollapse ? (
      <Image src={VoloteaLogo} sx={{ height: "40px", width: "40px" }} />
    ) : (
      <Image src={Volotea} sx={{ width: "100px" }} />
    );
  }

  // Loading state for custom logo (only if no theme)
  if (!hasCustomLogo && isLoadingCustomLogo) {
    return <Skeleton variant="circular" width={50} height={50} />;
  }

  // Backend custom logo
  if (hasCustomLogo && !isLoadingCustomLogo) {
    return (
      <Image
        src={`${BACKEND}/api/vendorService/Suppliers/customLogo/${currentSupplierId}`}
        sx={{ width: "70px" }}
        effect="blur"
        loading="lazy"
      />
    );
  }

  // Default logos
  return isCollapse ? (
    <Image
      src={DostLogo}
      alt="Dost Logo"
      sx={{ height: "44px", width: "44px" }}
    />
  ) : (
    <Image
      src={showSageBranding ? DostSageLogo : NewDostLogo}
      sx={{ width: showSageBranding ? "180px" : "100px" }}
    />
  );
};

export default SupplierLogo;
